import { Candidate, ExamCandidatesArgs } from '@generated/base-types';
import { EntityData, initialEntityData } from '@new/common/utils/entity-data';
import { RemoteData } from '@new/common/utils/remote-data';

export interface ExamCandidatesStateModel {
  items: EntityData<Candidate[]>;
  selectedIds: string[];
  importMutation: RemoteData<Candidate[]>;
  order: ExamCandidatesArgs['order'];
}

export const examCandidatesStateDefaults: ExamCandidatesStateModel = {
  items: initialEntityData(),
  selectedIds: [],
  importMutation: { requestState: 'initial', error: undefined },
  order: ['omr.desc']
};
